import { Button } from 'antd';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { getQueryString } from '@sonar-software/sonar-http';
import { Link } from 'react-router-dom';
import React from 'react';
import { ReadOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { useFeatureFlag, useSonarObjectReference } from '@hooks';

export interface GoToDictionaryButtonProps {
	sonarObjectId: number | undefined;
}

export const GoToDictionaryButton: React.FC<GoToDictionaryButtonProps> = ({ sonarObjectId }) => {
	const isEnabled = useFeatureFlag(FeatureFlag.DataDictionary);
	const { displayName } = useSonarObjectReference(sonarObjectId ?? 0);

	if (!isEnabled || !sonarObjectId) {
		return null;
	}

	return (
		<Link
			to={ `${FULL_ROUTES.DATA_DICTIONARY}?${getQueryString({
				displayName,
				sonarObjectId
			})}` }>
			<Button
				className='go-to-dictionary-button'
				icon={ <ReadOutlined /> }
				type='primary'>
				{ COPY_SPECIFIC.GO_TO_DICTIONARY }
			</Button>
		</Link>
	);
};
